import { Component } from '@angular/core';
import {NgOptimizedImage} from "@angular/common";
import {RouterLink} from "@angular/router";

@Component({
  selector: 'app-hero-pages',
  standalone: true,
  imports: [
    NgOptimizedImage,
    RouterLink
  ],
  templateUrl: './hero-movi-link.component.html',
  styleUrl: './hero-movi-link.component.css'
})
export class HeroMoviLinkComponent {

  title = 'Movilink';
  subtitle1 = 'Atención Médica';
  subtitle2 = 'a domicilio';
  callToAction = '¡Solicítalo ahora!';
  routeImageMain = 'assets/img/movilink/mainImage.svg';

}
